var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1872_8442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25001 1.53059C4.57001 1.53059 1.58334 4.51726 1.58334 8.19726C1.58334 11.8773 4.57001 14.8639 8.25001 14.8639C11.93 14.8639 14.9167 11.8773 14.9167 8.19726C14.9167 4.51726 11.93 1.53059 8.25001 1.53059ZM6.44334 11.0573L4.05001 8.66393C3.79001 8.40393 3.79001 7.98393 4.05001 7.72393C4.31001 7.46393 4.73001 7.46393 4.99001 7.72393L6.91668 9.64393L11.5033 5.05726C11.7633 4.79726 12.1833 4.79726 12.4433 5.05726C12.7033 5.31726 12.7033 5.73726 12.4433 5.99726L7.38334 11.0573C7.13001 11.3173 6.70334 11.3173 6.44334 11.0573Z",
    fill: "#29C18C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1872_8442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25 0.197266)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.b087d1d11cddb1e8c78cf0c6a7bde87e.svg";
export { ForwardRef as ReactComponent };